import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { VendorContext } from "../../../context/vendor/VendorContext";
import { ContactContext } from "../../../context/contact/ContactContext";
import { Container, Column, Tittle, Root } from "./style";
import { Dialog, LinearProgress } from "@mui/material";
import { ButtonUpload } from "../Enrollment/style";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { OneColumn } from "../Enrollment/naturalPerson/step3/style";
import UpdateDialog from "../Contact/Approvals/secondAccounts/updateDialog";
import { H3, SearchButton } from "../style";

const ManageDocumentation = () => {
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(true);
  const [alertUpdateInfo, setAlertUpdateInfo] = useState(false);
  const [success, setSuccess] = useState(false);
  const {
    vendDocumentation,
    vendorInformation,
    companyInformation,
    getVendorUpdDocumentation,
    getBase64,
    sendVendDocumentation,
    sendVendDocumentationAX,
  } = useContext(VendorContext);
  const { currentContact } = useContext(ContactContext);
  const [updateInfoMessage, setUpdateInfoMessage] = useState(true);
  const uploadCedula = useRef(null);
  const uploadRegistroUnico = useRef(null);
  const uploadDeclaracionImpRenta = useRef(null);
  const uploadObligacionesIESS = useRef(null);
  const uploadReferenciaClientes = useRef(null);
  const uploadNombramientoRepLegal = useRef(null);
  const uploadImpRenta = useRef(null);
  const uploadInfResponSocial = useRef(null);
  const uploadMisionVision = useRef(null);
  const uploadDeclaIVA = useRef(null);

  const handleUpload = (e, tag) => {
    e.preventDefault();
    if (tag === 1) {
      uploadCedula.current.click();
    } else if (tag === 2) {
      uploadRegistroUnico.current.click();
    } else if (tag === 3) {
      uploadDeclaracionImpRenta.current.click();
    } else if (tag === 4) {
      uploadObligacionesIESS.current.click();
    } else if (tag === 5) {
      uploadReferenciaClientes.current.click();
    } else if (tag === 6) {
      uploadNombramientoRepLegal.current.click();
    } else if (tag === 8) {
      uploadImpRenta.current.click();
    } else if (tag === 9) {
      uploadInfResponSocial.current.click();
    } else if (tag === 10) {
      uploadMisionVision.current.click();
    } else if (tag === 11) {
      uploadDeclaIVA.current.click();
    }
  };
  const handleFileUpload = (event) => {
    let resp = false;
    getBase64(event.target.files[0])
      .then(async (data) => {
        setAlertUpdateInfo(true);
        vendDocumentation[event.target.name] = data;
        const dataToSendAX = {
          id: "",
          guiD_VEND: "",
          banK_ID: "",
          entitY_ID: "",
          cedula: "",
          cedulA_RZ: "",
          obligacioneS_IESS: "",
          obligacioneS_IESS_RZ: "",
          registrO_UNICO: "",
          registrO_UNICO_RZ: "",
          referenciA_CLIENTES: "",
          referenciA_CLIENTES_RZ: "",
          certificadO_BANCARIO: "",
          declaracioN_IMP_RENTA: "",
          declaracioN_IVA: "",
          datE_CREATED: "",
          nombramientO_REPRESENTANTE_LEGAL: "",
          nombramientO_REPRESENTANTE_LEGAL_RZ: "",
          informE_RESPONSABILIDAD_SOCIAL: "",
          visioN_MISION_VALORES: "",
          estandareS_ETICOS: "",
          declaracion: "",
          afiliacioN_IESS_CONTACTO: "",
        };
        dataToSendAX[event.target.name] = data;
        dataToSendAX["id"] = vendDocumentation.id;
        dataToSendAX["guiD_VEND"] = vendDocumentation.guiD_VEND;
        dataToSendAX["banK_ID"] = vendDocumentation.banK_ID;
        dataToSendAX["entitY_ID"] = vendDocumentation.entitY_ID;
        dataToSendAX["datE_CREATED"] = vendDocumentation.datE_CREATED;
        resp = await sendVendDocumentationAX(dataToSendAX, vendorInformation);
        if (resp) {
          resp = false;
          resp = await sendVendDocumentation(vendDocumentation);
          console.log(resp);
          if (resp) {
            setSuccess(true);
          } else {
            setSuccess(false);
          }
          setTimeout(() => {
            setAlertUpdateInfo(false);
            setSuccess(false);
          }, 2500);
        } else {
          setTimeout(() => {
            setAlertUpdateInfo(false);
            setSuccess(false);
          }, 2500);
          alert("Error interno");
        }
      })
      .catch((error) => {
        alert("Error: " + error.currentTarget.error);
      });
  };
  const handleCloseCountry = () => {
    setUpdateInfoMessage(false);
  };
  const submitForm = async (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getVendorUpdDocumentation(currentContact)]);
      setLoading(false);
    };
    fetchData2();
  }, []);

  if (isLoading) {
    return <LinearProgress color="error" />;
  }

  return (
    <>
      {companyInformation.id === "" &&
      companyInformation.businesS_NAME === "" ? (
        <Dialog
          style={{ textAlign: "center" }}
          onClose={handleCloseCountry}
          open={updateInfoMessage}
        >
          <br />
          <Container>
            <H3>{t("vendUpdInfoNotification")}</H3>
          </Container>
          <Container>
            <OneColumn>
              <SearchButton onClick={handleCloseCountry}>
                {t("close")}
              </SearchButton>
            </OneColumn>
          </Container>
        </Dialog>
      ) : (
        <>
          {alertUpdateInfo && (
            <UpdateDialog
              success={success}
              showDialogUpdate={alertUpdateInfo}
              setShowDialogUpdate={setAlertUpdateInfo}
            />
          )}
          <form onSubmit={submitForm}>
            <Root>
              {vendorInformation.country === "ECU" && (
                <>
                  <Tittle>{t("documentation")}</Tittle>
                  <Container>
                    <Column>
                      <ButtonUpload onClick={(e) => handleUpload(e, 1)}>
                        {t("copyID")}
                        <UploadFileIcon />
                      </ButtonUpload>
                      <input
                        type="file"
                        accept="application/pdf"
                        name={"cedula"}
                        ref={uploadCedula}
                        onChange={(e) => handleFileUpload(e)}
                        style={{ display: "none" }}
                      />
                    </Column>
                    <Column>
                      <ButtonUpload onClick={(e) => handleUpload(e, 4)}>
                        {t("obligationsIessSri")}
                        <UploadFileIcon />
                      </ButtonUpload>
                      <input
                        type="file"
                        accept="application/pdf"
                        name={"obligacioneS_IESS"}
                        ref={uploadObligacionesIESS}
                        onChange={(e) => handleFileUpload(e)}
                        style={{ display: "none" }}
                      />
                    </Column>
                    <Column>
                      <ButtonUpload onClick={(e) => handleUpload(e, 2)}>
                        {t("copyRuc")}
                        <UploadFileIcon />
                      </ButtonUpload>
                      <input
                        type="file"
                        accept="application/pdf"
                        name={"registrO_UNICO"}
                        ref={uploadRegistroUnico}
                        onChange={(e) => handleFileUpload(e)}
                        style={{ display: "none" }}
                      />
                    </Column>
                    <Column>
                      <ButtonUpload onClick={(e) => handleUpload(e, 5)}>
                        {t("referencesClients")}
                        <UploadFileIcon />
                      </ButtonUpload>
                      <input
                        type="file"
                        accept="application/pdf"
                        name={"referenciA_CLIENTES"}
                        ref={uploadReferenciaClientes}
                        onChange={(e) => handleFileUpload(e)}
                        style={{ display: "none" }}
                      />
                    </Column>
                    {vendorInformation.type === "2" && (
                      <Column>
                        <ButtonUpload onClick={(e) => handleUpload(e, 6)}>
                          {t("docLegalRep")}
                          <UploadFileIcon />
                        </ButtonUpload>
                        <input
                          type="file"
                          accept="application/pdf"
                          name={"nombramientO_REPRESENTANTE_LEGAL"}
                          ref={uploadNombramientoRepLegal}
                          onChange={(e) => handleFileUpload(e)}
                          style={{ display: "none" }}
                        />
                      </Column>
                    )}
                    <Column>
                      <ButtonUpload onClick={(e) => handleUpload(e, 8)}>
                        {t("declarationVatLastYear")}
                        <UploadFileIcon />
                      </ButtonUpload>
                      <input
                        type="file"
                        accept="application/pdf"
                        name={"declaracioN_IMP_RENTA"}
                        ref={uploadImpRenta}
                        onChange={(e) => handleFileUpload(e)}
                        style={{ display: "none" }}
                      />
                    </Column>
                    {vendorInformation.type === "2" && (
                      <>
                        <Column>
                          <ButtonUpload onClick={(e) => handleUpload(e, 9)}>
                            {t("attachSocialReport")}
                            <UploadFileIcon />
                          </ButtonUpload>
                          <input
                            type="file"
                            accept="application/pdf"
                            name={"informE_RESPONSABILIDAD_SOCIAL"}
                            ref={uploadInfResponSocial}
                            onChange={(e) => handleFileUpload(e)}
                            style={{ display: "none" }}
                          />
                        </Column>
                        <Column>
                          <ButtonUpload onClick={(e) => handleUpload(e, 10)}>
                            {t("attachMissionVision")}
                            <UploadFileIcon />
                          </ButtonUpload>
                          <input
                            type="file"
                            accept="application/pdf"
                            name={"visioN_MISION_VALORES"}
                            ref={uploadMisionVision}
                            onChange={(e) => handleFileUpload(e)}
                            style={{ display: "none" }}
                          />
                        </Column>
                      </>
                    )}
                    {vendorInformation.type === "1" && (
                      <>
                        <Column>
                          <ButtonUpload onClick={(e) => handleUpload(e, 11)}>
                            {t("attachIvaReturn")}
                            <UploadFileIcon />
                          </ButtonUpload>
                          <input
                            type="file"
                            accept="application/pdf"
                            name={"declaracioN_IVA"}
                            ref={uploadDeclaIVA}
                            onChange={(e) => handleFileUpload(e)}
                            style={{ display: "none" }}
                          />
                        </Column>
                      </>
                    )}
                  </Container>
                </>
              )}
            </Root>
          </form>
        </>
      )}
    </>
  );
};

export default ManageDocumentation;
